import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { getImgUrl } from '../../utils';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();

    const IS_JP_SITE = locale === 'jp';
    const cardImgs = {
        jp: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745312555148/a.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745312555131/a-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745312555131/a-h5.jpg',
        },
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744343310211/t1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744343310211/t1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744343309501/t1-h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744702463418/t1-ss.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744702463418/t1-ss.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744702462889/t1-ss-h5.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719178306/b-uk.jpg',
        },
        nl: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719178306/b-uk.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719178306/b-uk.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718380283/fr.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718380283/fr.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719177936/b-fr.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718380499/it.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718380499/it.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719178116/b-it.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718353367/de.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718353367/de.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719177753/b-es.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718380140/es.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718380140/es.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719177753/b-es.jpg',
        },
        au: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718353616/uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719178306/b-uk.jpg',
        },
    };

    return (
        <div className="GtmModuleData-section" data-section-id="BlackA" data-section-classname=".black-a-title">
            <div className={styles.title}>
                <EcoTitle className="black-a-title" title={t('G_title')}></EcoTitle>
            </div>
            <div className={styles.comp} id="BlackA">
                <EcoSectionCard theme="black" layout="center-left" label={t('G_label')} title={t('G_subTitle')} desc={t('G_desc')} {...getImgUrl(cardImgs)} />
            </div>
        </div>
    );
}
